import React from 'react';

import { trans } from '@spotahome/soyuz/client';

import GenericBanner from '@search/components/GenericBanner';

const NoDepositBanner = () => (
  <GenericBanner
    dataTest={'no-deposit-banner'}
    content={trans('no-deposit-banner.content.text')}
    label={trans('no-deposit-banner.header.label')}
    color={'blue-indigo'}
  />
);

export default NoDepositBanner;
